import { ComponentConfig } from "@measured/puck";

import { ArticlesSection as ArticlesSectionComponent } from "./ArticlesSection";
import { ArticlesSectionWrapper } from "./components/ArticlesSectionWrapper";
import { ArticlesSectionProps } from "./types";
import RichTextEditorField from "../../fields/RichTextEditorField";

export type { ArticlesSectionProps } from "./types";

export const ArticlesSection: ComponentConfig<ArticlesSectionProps> = {
    label: "Articles Section",
    fields: {
        articles: {
            type: "array",
            label: "Articles",
            arrayFields: {
                title: {
                    type: "text",
                    label: "Title",
                },
                description: {
                    type: "custom",
                    label: "Description",
                    render: (props) => <RichTextEditorField {...props} />,
                },
                imageSrc: {
                    type: "text",
                    label: "Image URL",
                },
            },
        },
    },
    defaultProps: {
        articles: [
            {
                title: "Article 1",
                description: "Description for article 1",
                imageSrc: "https://placehold.co/500x700",
            },
            {
                title: "Article 2",
                description: "Description for article 2",
                imageSrc: "https://placehold.co/500x700",
            },
            {
                title: "Article 3",
                description: "Description for article 3",
                imageSrc: "https://placehold.co/500x700",
            },
        ],
    },
    render: (props) => {
        return (
            <ArticlesSectionWrapper>
                <ArticlesSectionComponent {...props} />
            </ArticlesSectionWrapper>
        );
    },
};
